import BaseMenuFetchComponent from 'frontend/components/base-menu-fetch';

export interface FooterSubMenuComponentArgs {}

export default class FooterSubMenuComponent extends BaseMenuFetchComponent {}
